
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.54 8L11 4.46l1.41-1.41 2.12 2.12L18.77.93l1.41 1.41L14.54 8zM9 4H0v2h9V4zm10 6.41L17.59 9 15 11.59 12.41 9 11 10.41 13.59 13 11 15.59 12.41 17 15 14.41 17.59 17 19 15.59 16.41 13 19 10.41zM9 12H0v2h9v-2z","fill":"#0B0E1F"}})])
          )
        }
      }
    